export enum Bundle {
  Professional = 'com.3d4medical.caweb.b2cprolicense',
  Student = 'com.3d4medical.caweb.b2cstupluslicense',
  Institutional = 'com.3d4medical.ca.institutional',
}
